<app-user-dashboard [fullScreen]="true">
  <div class="bg-container" id="virtual-comex">
    <div class="container">
      <div class="column-img fade-in-right-js only-desktop">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/comex_virtual.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

      <div class="column-info fade-in-up-js">
        <h1 class="title fade-in fade-in-delay">{{'ComexPage.Title' | translate}}<br>{{'ComexPage.Title2' | translate}}</h1>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-2">
            <i class="figure-circle"></i>
            <!--
              <i class="pi pi-check figure-icon"></i>
            -->
            <h3 class="subtitle-main">
              {{'ComexPage.Subtitle1' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-3">
            {{'ComexPage.Text1Part1' | translate}} <strong style="font-weight:600">{{'ComexPage.Text1Part2' | translate}} </strong>{{'ComexPage.Text1Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-4">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'ComexPage.Subtitle2' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-5">
            {{'ComexPage.Text2Part1' | translate}} <strong style="font-weight:600">{{'ComexPage.Text2Part2' | translate}} </strong>{{'ComexPage.Text2Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-6">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'ComexPage.Subtitle3' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-7">
            {{'ComexPage.Text3Part1' | translate}} <strong style="font-weight:600">{{'ComexPage.Text3Part2' | translate}} </strong>{{'ComexPage.Text3Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-8">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'ComexPage.Subtitle4' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-9">
            <strong style="font-weight:600">{{'ComexPage.Text4Part1' | translate}} </strong>{{'ComexPage.Text4Part2' | translate}}.
          </p>
        </div>

      </div>

      <div class="column-img fade-in-right-js only-mobile">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/comex_virtual.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

    </div>
  </div>

  <!--
      <p class="text">
        {{'ToDoFruzty.slide_1.description' | translate}}
        <strong>
          {{'ToDoFruzty.slide_1.descriptionStrong' | translate}}
        </strong>
        {{'ToDoFruzty.slide_1.lastDescription' | translate}}
      </p>
      <div class="container-flex">
        <section class="column-left">
          <h2 class="subtitle">
            {{'ToDoFruzty.subtitle-items' | translate}}
            <i class="pi pi-verified figure-icon-large"></i>

          </h2>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_1.item_1' | translate}}
          </p>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_1.item_2' | translate}}
          </p>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_1.item_3' | translate}}
          </p>
        </section>
        <section class="column-right">
          <figure class="figure-img">
            <img src="../../../../assets/img/to_do_fruzty/QPHF-01-T.png" style="width: 100%" alt="flag"/>

          </figure>

        </section>
      </div>
    </div>
  </div>
  <div class="bg-container-white" id="find-and-connect">
    <div class="container-align-right">
      <h1 class="title">{{'ToDoFruzty.slide_2.title' | translate}}</h1>
      <p class="text">
        {{'ToDoFruzty.slide_2.description' | translate}}
        <strong>
          {{'ToDoFruzty.slide_2.descriptionStrong' | translate}}
        </strong>
        {{'ToDoFruzty.slide_2.lastDescription' | translate}}
      </p>
      <div class="container-flex flex-reverse">
        <section class="column-right">
          <figure class="figure-img">
            <img src="../../../../assets/img/to_do_fruzty/QPHF-02-T_.png" style="width: 100%" alt="flag"/>

          </figure>

        </section>
        <section class="column-right-text">
          <h2 class="subtitle">
            {{'ToDoFruzty.subtitle-items' | translate}}
            <i class="pi pi-verified figure-icon-large"></i>
          </h2>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_2.item_1' | translate}}
          </p>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_2.item_2' | translate}}
          </p>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_2.item_3' | translate}}
          </p>
        </section>
      </div>

    </div>
  </div>
  <div class="bg-container"  id="import-program">
    <div class="container">
      <h1 class="title">{{'ToDoFruzty.slide_3.title' | translate}}</h1>
      <p class="text">
        {{'ToDoFruzty.slide_3.description' | translate}}
      </p>
      <div class="container-flex">
        <section class="column-left">
          <h2 class="subtitle">
            {{'ToDoFruzty.subtitle-items' | translate}}
            <i class="pi pi-verified figure-icon-large"></i>
          </h2>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_3.item_1' | translate}}
          </p>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_3.item_2' | translate}}
          </p>
          <p class="text-item">
            <i class="pi pi-check-circle figure-icon"></i>
            {{'ToDoFruzty.slide_3.item_3' | translate}}
          </p>
        </section>
        <section class="column-right">
          <figure class="figure-img">
            <img src="../../../../assets/img/to_do_fruzty/QPHF-03-T.png" style="width: 100%" alt="flag"/>

          </figure>

        </section>
      </div>

    </div>
  </div>
  -->
</app-user-dashboard>

<app-footer-home></app-footer-home>

